import { AutenticacionService } from '../../../services/autenticacion.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare var $;

@Component({
  selector: 'app-ticket-ayuda-modal',
  templateUrl: './ticket-ayuda-modal.component.html',
  styleUrls: ['./ticket-ayuda-modal.component.scss']
})
export class TicketAyudaModalComponent implements OnInit {
  ngOnInit() {
  }

  reset() {
    this.close();
  }

  open() {
    $('#ticketAyudaModal').modal('show');
  }

  close() {
    $('#ticketAyudaModal').modal('hide');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/partials/ticket-ayuda-modal/ticket-ayuda-modal.component.ts